import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/views/company/CompanyRolesAndPermissions.scss';
import { createSidebar } from '../../redux/actions/general/sidebar';
import { __, mapStateToProps, resetForm } from '../../core/utils';
import { listActiveModules } from '../../redux/actions/general/active_modules';
import { readProfile } from '../../redux/actions/profile';
import autobind from 'autobind-decorator';
import moment from 'moment';
import TitleBar from '../../containers/TitleBar';
import CompanyRolesAndPermissionsForm from '../../forms/company/CompanyRolesAndPermissionsForm';
import {
  listPermissionsManager,
  listRolePermissions,
  listRoles,
  listUserPermissions,
  listUsers,
  saveRolePermissions,
} from '../../redux/actions/table/company_roles_and_permissions';
import Select from '../../components/Select';

@mapStateToProps((state) => ({
  profile: state.profile,
  auth: state.auth,
}))
class CompanyRolesAndPermissions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_user_id: null,
      is_active_user_select: false,

      selected_role_id: null,
      is_active_role_select: false,

      users: [],
      roles: [],

      role_permissions: [],
      permissions: [],
    };
  }

  componentDidMount() {
    listActiveModules();

    createSidebar({
      title: __('topbar.account.company-settings'),
      items: [
        {
          title: __('submenu.title.company-details'),
          link: () => '/company/details',
        },
        {
          title: __('submenu.title.offices'),
          link: () => '/company/offices',
        },
        {
          title: __('company-settings.submenu.title.brands'),
          link: () => '/company/brands',
        },
        {
          title: __('company-settings.submenu.title.disciplines'),
          link: () => '/company/disciplines',
        },
        {
          title: __('submenu.title.market'),
          link: () => '/company/market',
        },
        {
          title: __('submenu.title.company_holidays'),
          link: () => '/company/company_holidays',
        },
        {
          title: __('submenu.title.company_positions'),
          link: () => '/company/company_positions',
        },
        {
          title: __('submenu.title.company_segments'),
          link: () => '/company/company_segments',
        },
        {
          title: __('submenu.title.company_benefits'),
          link: () => '/company/company_benefits',
        },
        {
          title: __('submenu.title.company_folders'),
          link: () => '/company/company_folders',
        },
        {
          title: __('submenu.title.planning_templates'),
          link: () => '/company/planning-templates/stages',
        },
        {
          title: __('submenu.title.tags'),
          link: () => '/company/tags',
        },
        _.includes(
          this.props.auth?.permissions,
          'view.permissions.in.permission.manager'
        )
          ? {
              title: __('submenu.title.company_roles_and_permissions'),
              link: () => '/company/company_roles_and_permissions',
              active: true,
            }
          : null,
      ].filter(Boolean),
      // {
      //     title: __("submenu.title.subscription-and-billing"),
      //     link: () => "/company/subscription"
      // }
    });

    listUsers().then(({ response }) => {
      this.setState({ users: response.data });
    });

    listRoles().then(({ response }) => {
      this.setState({ roles: response.data });
    });

    listPermissionsManager().then(({ response }) => {
      this.setState({ list_permissions: response.data });
    });

    readProfile();
  }

  @autobind
  _handleSubmit(formData) {
    const user_id = this.state.selected_user_id;

    const role_id = this.state.selected_role_id;

    const permissionKeys = _.keys(formData.permissions || {});
    const numericPermissionKeys = _.map(permissionKeys, (key) => Number(key));

    // return saveRolePermissions({ permissions: numericPermissionKeys }, user_id);
  }

  render() {
    const { profile } = this.props;
    const { list_permissions } = this.state;

    //TO DO : clean this code when custom roles handling is added and changing permissions is enabled

    return (
      <>
        <TitleBar
          toolbar
          title={__('company-settings.company-roles-and-permissions.title')}
          dropdownHeader={__('topbar.account.company-settings')}
        />
        {/* <div className={styles.header}>
          <div className={styles.title}>
            {__('submenu.title.company_roles_and_permissions')}
          </div>
          <div className={styles.subtitle}>
            {!_.isEmpty(profile.disciplines) &&
              _.map(profile.disciplines, (discipline) =>
                getLocalizedListValue(
                  this.props.localization.disciplines,
                  discipline,
                  'profession'
                )
              ).join(', ') + ' · '}
            {profile.company} · {profile.email}
          </div>
        </div> */}

        <div className={styles.wrapper}>
          <div className={styles.flex}>
            <div className={styles.f1} style={{ marginLeft: '30px' }}>
              <Select
                input={{
                  // value: this.state.selected_user_id,
                  value: this.state.selected_role_id,
                  // onChange: (user_id) => {
                  onChange: (role_id) => {
                    // this.setState({ selected_user_id: user_id });
                    this.setState({ selected_role_id: role_id });

                    resetForm('profile.company_and_roles_permissions');

                    {
                      /* listUserPermissions(user_id).then(({ response }) => {
                      this.setState({ permissions: response.data });
                    }); */
                    }

                    listRolePermissions(role_id).then(({ response }) => {
                      this.setState({
                        permissions: response.data,
                      });
                    });
                  },
                  onFocus: () => this.setState({ is_active_user_select: true }),
                  onBlur: () => this.setState({ is_active_user_select: false }),
                }}
                meta={{
                  active: this.state.is_active_user_select,
                }}
                label={__(
                  'company-settings.company-roles-and-permissions.roles'
                )}
                //options={_.map(this.state.users, (user) => ({
                //  label: user.fullname,
                //  value: user.id,
                //}))}
                options={_.map(this.state.roles, (role) => ({
                  label: role.name,
                  value: role.id,
                }))}
                placeholder={__(
                  'company-settings.company-roles-and-permissions.select-role'
                )}
                top={28}
                noSort
                searchable
              />
            </div>
            <div className={styles.f1} />
          </div>
          {/* <div className={styles.flex}>
            <div className={styles.f1}>
              <Select
                disabled={!this.state.selected_user_id}
                input={{
                  value: this.state.selected_role_id,
                  onChange: (role_id) => {
                    this.setState({ selected_role_id: role_id });
                  },
                  onFocus: () => this.setState({ is_active_role_select: true }),
                  onBlur: () => this.setState({ is_active_role_select: false }),
                }}
                meta={{
                  active: this.state.is_active_role_select,
                }}
                label={'Roles'}
                options={_.map(this.state.roles, (role) => ({
                  label: role.name,
                  value: role.id,
                }))}
                top={28}
                noSort
                searchable
              />
            </div>
            <div className={styles.f1} />
          </div> */}
        </div>
        <CompanyRolesAndPermissionsForm
          listPermissions={list_permissions}
          onSubmit={this._handleSubmit}
          // user_id={this.state.selected_user_id}
          user_id={this.state.selected_role_id}
          initialValues={{
            permissions: this.state.permissions,
          }}
        />
      </>
    );
  }
}

export default CompanyRolesAndPermissions;
